import { X } from 'lucide-react'

export interface FiltroAtivo {
  id: string
  label: string
  onRemove: () => void
}

interface FiltrosAtivosProps {
  filtros: FiltroAtivo[]
  onLimpar: () => void
}

/** Chips dos filtros aplicados, removíveis um a um. */
export function FiltrosAtivos({ filtros, onLimpar }: FiltrosAtivosProps) {
  if (filtros.length === 0) return null
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-medium text-fg-subtle">Filtros:</span>
      {filtros.map((filtro) => (
        <span
          key={filtro.id}
          className="inline-flex items-center gap-1 rounded-full border border-brand/30 bg-brand/8 py-0.5 pl-2.5 pr-1 text-xs font-medium text-fg"
        >
          {filtro.label}
          <button
            type="button"
            onClick={filtro.onRemove}
            aria-label={`Remover filtro ${filtro.label}`}
            className="grid size-5 place-items-center rounded-full text-fg-muted hover:bg-brand/15 hover:text-fg"
          >
            <X className="size-3" />
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={onLimpar}
        className="text-xs font-medium text-brand hover:underline"
      >
        Limpar tudo
      </button>
    </div>
  )
}
